import _ from "lodash";

export const   selectAlertStatus=(basketItems)=>{
    
    let countbasketItemsperson = 0;
    let countstate4 = 0;
    let countstate1 = 0;
    let countOther = 0;
 
        if (!_.isEmpty(basketItems.basketItemPersons)) {
            basketItems.basketItemPersons.map((canclItem)=>{
                switch (canclItem.cancelStatus) {
                    case 4:
                      countstate4++;
                      break;
                    case 1:
                      countstate1++;
                      break;
                    default: 
                     ([2,3,5]).indexOf(canclItem.cancelStatus)!=-1 &&                       
                      countOther++;
                      break;
                  }//swith case
                  countbasketItemsperson++;

            })//basketItems.basketItemPersons.map
        }//If basketItems.basketItemPersons
    
  
    if (countbasketItemsperson == countstate4 )
   {       
    return "کل آیتم ها کنسل شده است.";}
   else if (countstate4 !=0 )
   {
    return countstate4+" آیتم از "+countbasketItemsperson+ " آیتم کنسل شده است.";
    }
   else if (countstate1 !=0 )
   return "ثبت_کنسلی";
   else if (countOther !=0 )
   return <span className='text-info font-weight-bold '>موارد_دیگر</span>;
   else
    return <span className='text-primary font-weight-bold '>فعال</span>;
    

}
